import { iAlturaGrafico } from "../interfaces/iLayout";

export function formatarReal(val: any, addRS: boolean = true) {
  val = Math.round(val * 100) / 100;
  val = val.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
  if (addRS) return "R$ " + val;
  return val;
}

export function proximaSextaFeira() {
  const hoje = new Date();
  const diaDaSemana = hoje.getDay(); // Obtém o dia da semana
  // Calcula quantos dias faltam até a sexta-feira (dia 5 da semana)
  const diasFaltantes = (5 + 7 - diaDaSemana) % 7;
  const dataSextaFeira = new Date(hoje);
  dataSextaFeira.setDate(hoje.getDate() + diasFaltantes);
  const dia = String(dataSextaFeira.getDate()).padStart(2, '0');
  const mes = String(dataSextaFeira.getMonth() + 1).padStart(2, '0'); // Mês começa de 0 (janeiro) a 11 (dezembro)
  const ano = dataSextaFeira.getFullYear();
  return `${dia}/${mes}/${ano}`;
}

export function getUltimoDiaMes() {
  const hoje = new Date();
  const ultimoDia: any = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
  const Dia = String(ultimoDia.getDate()).padStart(2, '0');
  const mes = String(ultimoDia.getMonth() + 1).padStart(2, '0');
  const ano = ultimoDia.getFullYear();
  return `${Dia}/${mes}/${ano}`;
}

export function getHeight(Altura: iAlturaGrafico) {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  const resolucao: Array<[number, number, number]> = [
    [1670, 670, Altura.A1920xL1080],
    [1430, 640, Altura.A1680xL1050],
    [1350, 490, Altura.A1600xL900],
    [1190, 490, Altura.A1440xL900],
    [1150, 640, Altura.A1400xL1050],
    [1110, 358, Altura.A1366xL768],
    [1030, 614, Altura.A1280xL1024],
    [1030, 550, Altura.A1280xL960],
    [1030, 390, Altura.A1280xL800],
    [1030, 358, Altura.A1280xL768],
    [1030, 310, Altura.A1280xL720],
    [1030, 190, Altura.A1280xL600],
    [902, 454, Altura.A1152xL864],
    [774, 358, Altura.A1024xL768],
    [550, 171, Altura.A800xL600],
  ]

  for (const [minWidth, minHeight, altura] of resolucao) {
    if (screenWidth >= minWidth && screenHeight >= minHeight) {
      return altura;
    }
  }

  return undefined;
}